// Logo Configuration
// Update these paths after uploading your logo files

export const LOGO_CONFIG = {
  // Main logo for light backgrounds
  main: '/images/logo/logo.png',
  
  // White version for dark backgrounds
  white: '/images/logo/logo-white.png',
  
  // SVG version (if available) - best for scalability
  svg: '/images/logo/sample-logo.svg',
  
  // Square version for social media/favicons
  square: '/images/logo/logo-square.png',
  
  // Fallback text when logo is not available
  fallbackText: 'DFITCLUB',
  
  // Logo dimensions
  dimensions: {
    width: 200,
    height: 80,
    navbar: {
      width: 150,
      height: 60
    },
    mobile: {
      width: 120,
      height: 48
    }
  },
  
  // Alt text for accessibility
  altText: 'DFITCLUB - Health & Nutrition by Deeksha Rajput'
};

// Helper function to check if logo exists
export const checkLogoExists = async (logoPath) => {
  try {
    const response = await fetch(logoPath, { method: 'HEAD' });
    return response.ok;
  } catch {
    return false;
  }
};

// Get the best available logo format
export const getBestLogo = async () => {
  // Priority order: SVG > PNG > Fallback
  const logoOptions = [LOGO_CONFIG.svg, LOGO_CONFIG.main];
  
  for (const logo of logoOptions) {
    if (await checkLogoExists(logo)) {
      return logo;
    }
  }
  
  return null; // Use fallback text
};

export default LOGO_CONFIG;